import { useQuery } from 'react-query';

import { api } from '../api';

export type PlanId = 'ZIG15' | 'ZIG30' | 'ZIG70';

export const PLANO_PADRAO: PlanId = 'ZIG30';

export interface Plano {
  id: number;
  document: string;
  plan: PlanId;
  created_at: string;
  updated_at: string;
}

export async function getPlanos(): Promise<Plano[]> {
  const { data } = await api.get<Plano[]>('plans');
  return data;
}

export async function savePlano(document: string, plan: PlanId): Promise<Plano> {
  const { data } = await api.post<Plano>('plans', { document, plan });
  return data;
}

export async function deletePlano(id: number): Promise<void> {
  await api.delete(`plans/${id}`);
}

export async function getPlanoByDocument(
  document: string
): Promise<{ document: string; plan: PlanId }> {
  const { data } = await api.get<{ document: string; plan: PlanId }>(
    `plans/${document}`
  );
  return data;
}

const hasToken = () =>
  String(api.defaults.headers.common.authorization).length > 10;

export function usePlanos() {
  return useQuery('plans', getPlanos, {
    enabled: hasToken(),
    staleTime: Infinity,
    retry: 1,
  });
}

// usado pelo Simulador: resolve o plano do CNPJ selecionado (cai em ZIG30 se nao houver)
export function usePlanoByDocument(document?: string) {
  return useQuery(
    ['plan', document],
    () => getPlanoByDocument(document as string),
    {
      enabled: !!document && hasToken(),
      staleTime: Infinity,
      retry: 1,
    }
  );
}
